import React, { useState, useContext, useEffect } from 'react';
import DialogEditSubscribe from "../subscribe/DialogEditSubscribe"
import { AuthContext } from "../../common/Auth"
import { USERTYPES } from "../../constant/userType"

export default function SubscribeEditIcon ({ subscribeId, fromEditAction }) {

    const { userType } = useContext(AuthContext)
    const [open, setOpen] = useState(false);
    const [toolTip, setToolTip] = useState('');
    const handleClose = () => {
        setOpen(!open)
    }
    const handleOpen = () => {
        setOpen(!open)
    }

    useEffect(() => {
        if (fromEditAction && fromEditAction == 'title') {
            setToolTip('Update Title')
        } else if (fromEditAction && fromEditAction == 'subTitle') {
            setToolTip('Update Secondary Title')
        } else if (fromEditAction && fromEditAction == 'topBottomspace') {
            setToolTip('Update Top Bottom space')
        } else if (fromEditAction && fromEditAction == 'btn') {
            setToolTip('Update Button Design')
        } else if (fromEditAction && fromEditAction == 'img') {
            setToolTip('Update Background Image')
        }


    }, [fromEditAction])
    return (
        <>
            {userType && userType !== USERTYPES.USER && (
                <>
                    <h6 className="animated" onClick={() => { handleOpen() }}>
                        <i className="fa fa-edit" title={toolTip}></i>
                    </h6>
                    <DialogEditSubscribe open={open} handleClose={handleClose} subscribeId={subscribeId} fromEditAction={fromEditAction} />
                </>
            )}
        </>
    );
}